// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linesHeaderStyles } from "@awc/App/Components/Cart/LinesHeader";
import { color, getSystemColor, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

linesHeaderStyles.wrapper = {
    css: css`
        display: grid;
        ${({ showExtraCol }: any) =>
            showExtraCol
                ? "grid-template-columns: 2fr 4fr repeat(4,1fr);"
                : "grid-template-columns: 2fr 7fr repeat(3,1fr);"}
        grid-auto-flow: column;
        grid-column-gap: 6px;

        width: 100%;
        background: ${color("common.ui22")};

        padding: 20px 12px 16px;

        border: 1px solid ${color("common.border")};
        border-collapse: collapse;
        border-top: 6px solid ${color("common.ui14")};
        margin-bottom: 10px;

        @media print {
            border: 2px solid ${color("common.border")};
        }

        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr 5fr 2fr;
            ${({ showBorderBottom }: any) =>
                showBorderBottom && `border-bottom: 1px solid ${getSystemColor("common.border")}`};
        }
    `,
};
linesHeaderStyles.itemDescription = {
    css: css`
        grid-column: 1 / 3;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 5;
        }
    `,
};

linesHeaderStyles.priceUnit = {
    css: css`
        grid-column: 3 / 4;
        ${xScreen("lte", "md")} {
            grid-column: 5/6;
        }
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};
linesHeaderStyles.qty = {
    css: css`
        grid-column: 4 / 5;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
linesHeaderStyles.extraCol = {
    css: css`
        grid-column: 5 / 6;
        text-align: right;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

linesHeaderStyles.total = {
    css: css`
        text-align: right;
        ${({ showExtraCol }: any) => (showExtraCol ? "grid-column: 6 / 7;" : "grid-column: 5 / 6;")}
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

linesHeaderStyles.titleText = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
    ...{ as: "h3" },
};
